import styled from '@emotion/styled'

import theme from 'styles/theme'

export const ErrorMessage = styled.p`
  color: ${theme.token.var('colors.red.a150')};
  margin-top: 5px;
  font-size: ${theme.token.var('fontSizes.sm')};
`
